import React, { useState } from 'react';
import {connect} from 'react-redux';
import {Global} from '@emotion/react';
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import {Card, IconButton} from "@mui/material";
import CardContent from "@mui/joy/CardContent";
import {styled} from "@mui/material/styles";
import Box from '@mui/material/Box';
import {getFreakIcon} from "../../utils/freakUtils";
import ContextPicker from "../ContextPicker/ContextPicker";

const StyledBox = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  overflowY: 'auto',
}));

const Puller = styled('div')(({theme}) => ({
  width: 30,
  height: 6,
  position: 'absolute',
  top: 8,
  left: 'calc(50% - 15px)',
}));

const ContextSwipeableDrawerComponent = (props) => {
  const [open, setOpen] = useState(false);
  const context = props?.context || props?.currentUser?.context;

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const drawerBleeding = 0;

  return (
    <>
      <IconButton
        sx={{
          '&:focus': {
            outline: 'none'
          },
        }}
        onClick={() => {
          setOpen(true);
        }}
      >
        {getFreakIcon(context, () => setOpen(true))}
      </IconButton>
      <Global
        styles={{
          '.MuiDrawer-root > .MuiPaper-root': {
            height: `calc(100% - ${drawerBleeding}px)`,
            overflow: 'visible',
          },
        }}
      />
      <SwipeableDrawer
        anchor="top"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        disableDiscovery={true}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <StyledBox
          sx={{
            position: 'absolute',
            top: -drawerBleeding,
            visibility: 'visible',
            right: 0,
            left: 0,
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <Puller/>
          {
            open
              ? <Card sx={{
                height: '80vh',
                boxShadow: 'none',
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                overflowY: 'auto',
                borderRadius: 0,
              }}>
                <CardContent
                  sx={{
                    marginLeft: 2,
                    marginRight: 2,
                    marginTop: 1,
                    marginBottom: 24,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginTop: 5,
                    }}
                  >
                  </Box>
                  <ContextPicker compact onSelected={() => setOpen(false)}/>
                </CardContent>
              </Card>
              : null
          }
        </StyledBox>
      </SwipeableDrawer>
    </>
  )
};

const mapStateToProps = state => ({
  ...state,
  currentUser: state.common.currentUser,
  context: state.common.context,
});

export default connect(mapStateToProps)(ContextSwipeableDrawerComponent);
